export const SITE_COPY = {
  hero: {
    eyebrow: "Sr. Creative Developer",
    title: ["Davide", "Magnoni"],
    description: "I turn code, motion, and interaction into digital experiences that live on screens and beyond.",
    scrollLabel: "Scroll to project",
  },
  about: {
    eyebrow: "About / Capabilities",
    title: ["Designing motion.", "Building systems."],
    description: [
      "At EssilorLuxottica, I work across creative development, interaction design, and frontend engineering, building experiences for global events, permanent installations, and high-traffic digital platforms.",
      "My work spans real-time graphics, WebGL, interactive systems, and full-stack architectures, with a strong focus on performance, accessibility, and thoughtful user interaction.",
    ],
    skillsLabel: "Skills and technologies",
  },
  projects: {
    eyebrow: "Latest work",
    title: "Projects",
    description: "A selection of digital experiences shaped through design, motion, and realtime technology.",
    openLabel: "View case study",
  },
  contact: {
    eyebrow: "Start a conversation",
    title: ["Let's make", "something move."],
    description: "Tell me about the idea, the timeline, or the problem you are stuck on. Every message reaches my inbox directly.",
    fields: {
      name: { label: "Name", placeholder: "Your name" },
      email: { label: "Email", placeholder: "you@example.com" },
      message: { label: "Message", placeholder: "Tell me about the idea" },
    },
    // The decoy label is never shown, but assistive tech and autofill still read it.
    decoyLabel: "Subject",
    submitLabel: "Send message",
    sendingLabel: "Sending",
    idleNote: "I usually reply within a couple of days.",
    // Shown while CONTACT_FORM_ENABLED is false: the panel must not promise a reply it cannot deliver.
    standby: {
      description: "The form is being prepared. For now, the links below are the best way to reach me.",
      submitLabel: "Send — coming soon",
      note: "This form is not accepting messages yet. Please use the links below to reach me.",
    },
    status: {
      name: "Please add your name so I know who is writing.",
      email: "That email address looks incomplete. Please check it.",
      message: "Please add a few more words about the idea.",
      sending: "Sending your message…",
      success: "Thank you. Your message is on its way — I will reply by email.",
      rejected: "This message was flagged as automated. If that is wrong, write to me directly with the links below.",
      unavailable: "The form is temporarily unavailable. Please use the links below to reach me.",
      failed: "The message could not be sent. Please try again, or use the links below.",
    },
  },
  footer: {
    label: "Elsewhere",
    copyright: "Davide Magnoni",
  },
  caseStudy: {
    backLabel: "All projects",
    chapterLabel: "Chapter / 01",
    overviewLabel: "Project overview",
    galleryEyebrow: "Selected views",
    galleryLabel: "Project gallery",
    galleryPreviousLabel: "Previous view",
    galleryNextLabel: "Next view",
    videoPlayLabel: "Play video",
    videoPauseLabel: "Pause video",
  },
  notFound: {
    title: "Page not found",
    description: "The page you requested does not exist or is not published yet.",
    backLabel: "Back home",
  },
} as const;
